import { Repository } from 'src/components/types';

import { LoadSourceObject } from './';

export default (repo: Repository, hash: string, path: string) => ({
  type: LoadSourceObject.REQUEST,
  payload: { repo, hash, path },
});
